import { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { showCrispChatBox, hideCrispChatBox } from '../Lib/crispUtils';
import AutoComplete from './Autocomplete';

class GoogleSuggest extends Component {
  constructor(props) {
    super(props);
    this.state = {
      found: false,
    };
  }

  componentDidMount() {
    if (window.innerWidth < 800) {
      hideCrispChatBox();
    }
  }

  componentWillUnmount() {
    showCrispChatBox();
  }

  handleEnter = (e) => {
    if (this.state.found) {
      this.props.placeSelected(e);
    }
  };

  propagateUpdates = (description, placeDetails) => {
    try {
      // Preserve old logic
      this.setState({
        found: true,
      });

      this.props.placeSelected(false, placeDetails);
    } catch (e) {
      console.log(e);
      this.props.placeSelected(false, {
        name: '',
        phone: '',
        photos: [],
        address: '',
        selectedPhoto: '',
        location: {
          latitude: 0,
          longitude: 0,
        },
      });
    }
  };

  render() {
    const { onboardingDone } = this.props;
    const isInterview = this.props.isInterview || false;
    const { t } = this.props;

    return (
      <>
        {onboardingDone ? (
          <h2>
            {isInterview
              ? t('CompanyFind.interviewaddress')
              : t('CompanyFind.addcompany')}
          </h2>
        ) : (
          <div>
            <h2>{t('CompanyFind.welcome')}</h2>
            <h3>{t('CompanyFind.startbyaddingcompany')}</h3>
          </div>
        )}

        <AutoComplete
          isInterview={isInterview}
          handleEnter={this.handleEnter}
          propagateUpdates={this.propagateUpdates}
        />

        {isInterview ? false : (
          <div id="onboard_instructions">{t('CompanyFind.instructions')}</div>
        )}
      </>
    );
  }
}

export default withTranslation()(GoogleSuggest);
